/**
 * Eon API
 * The Eon.io REST API
 *
 * AUTOGENERATED: Do not edit the class manually.
 * Instead edit the .mustache file and run `node --run gen-openapi`
 */


export class ListSubnetsResponseV2SubnetsInner {
  /**
  * The id of the subnet
  */
  'id': string;
  /**
  * The vpc id of the subnet
  */
  'vpc': string;
  /**
  * The availability zone of the subnet
  */
  'availabilityZone': string;
  /**
  * The name of the subnet
  */
  'name'?: string;

  static readonly discriminator: string | undefined = undefined;

  static readonly attributeTypeMap: Array<{name: string, baseName: string, type: string, format: string}> = [
    {
      "name": "id",
      "baseName": "id",
      "type": "string",
      "format": ""
    },
    {
      "name": "vpc",
      "baseName": "vpc",
      "type": "string",
      "format": ""
    },
    {
      "name": "availabilityZone",
      "baseName": "availabilityZone",
      "type": "string",
      "format": ""
    },
    {
      "name": "name",
      "baseName": "name",
      "type": "string",
      "format": ""
    }  ];

  static getAttributeTypeMap() {
    return ListSubnetsResponseV2SubnetsInner.attributeTypeMap;
  }

  public constructor() {
  }
}

